import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="cron"
export default class extends Controller {
  static targets = [
    "repeats",
    "timeOfDay",
    "secondTimeEnabled",
    "secondTimeOfDay",
    "dayOfWeek",
    "dayOfMonth",
    "cadence",
  ];

  connect() {
    const cadence = this.cadenceTarget.value || "30 9 * * *";
    const [minute, hour, dayOfMonth, monthOfYear, dayOfWeek] = cadence.split(" ");
    const [primaryHour, secondHour] = hour.split(",");
    this.repeatsTarget.value = this.#repeatsFromCron(dayOfMonth, monthOfYear, dayOfWeek);
    this.timeOfDayTarget.value = `${primaryHour}:${minute}`;
    this.secondTimeEnabledTarget.checked = secondHour !== undefined;
    if (secondHour !== undefined) {
      this.secondTimeOfDayTarget.value = secondHour;
    }
    this.dayOfWeekTarget.value = dayOfWeek === "*" ? undefined : dayOfWeek;
    this.dayOfMonthTarget.value = dayOfMonth === "*" ? undefined : dayOfMonth;
    this.updateFields();
    this.#refreshSecondTimeOptions();
  }

  onChangeTime() {
    this.calculateCadence();
  }

  onChangeRepeat() {
    this.updateFields();
    this.calculateCadence();
  }

  onToggleSecondTime() {
    this.updateFields();
    this.calculateCadence();
  }

  updateFields() {
    const repeatFrequency = this.repeatsTarget.value;
    this.dayOfWeekTarget.hidden = repeatFrequency !== "weekly";
    this.dayOfMonthTarget.hidden = !["monthly", "quarterly"].includes(repeatFrequency);
    this.secondTimeOfDayTarget.hidden = !this.secondTimeEnabledTarget.checked;
  }

  calculateCadence() {
    this.#refreshSecondTimeOptions();

    const [primaryHour, minutesInput] = this.timeOfDayTarget.value.split(":");
    const minutes = minutesInput === "30" ? "30" : "0";

    let hourField = primaryHour;
    if (this.secondTimeEnabledTarget.checked) {
      hourField = `${primaryHour},${this.secondTimeOfDayTarget.value}`;
    }

    let cadence = minutes + " " + hourField;

    if (["monthly", "quarterly"].includes(this.repeatsTarget.value)) {
      cadence += " " + this.dayOfMonthTarget.value;
    } else {
      cadence += " *";
    }

    if (this.repeatsTarget.value === "weekly") {
      cadence += " * " + this.dayOfWeekTarget.value;
    } else if (this.repeatsTarget.value === "quarterly") {
      cadence += " */3 *";
    } else {
      cadence += " * *";
    }

    this.cadenceTarget.value = cadence;
  }

  #refreshSecondTimeOptions() {
    const [primaryHour, minutesInput] = this.timeOfDayTarget.value.split(":");
    const minutes = minutesInput === "30" ? "30" : "00";
    let firstVisible;
    for (const option of this.secondTimeOfDayTarget.options) {
      const hour = option.dataset.cronSecondHour;
      if (hour === undefined) continue;
      option.textContent = `at ${hour}:${minutes}`;
      const matchesPrimary = hour === primaryHour;
      option.hidden = matchesPrimary;
      option.disabled = matchesPrimary;
      if (!matchesPrimary && firstVisible === undefined) {
        firstVisible = hour;
      }
    }
    if (this.secondTimeOfDayTarget.value === primaryHour && firstVisible !== undefined) {
      this.secondTimeOfDayTarget.value = firstVisible;
    }
  }

  #repeatsFromCron(dayOfMonth, monthOfYear, dayOfWeek) {
    if (monthOfYear === "*/3") {
      return "quarterly";
    }

    if (dayOfMonth === "*") {
      return dayOfWeek === "*" ? "daily" : "weekly";
    }

    return "monthly";
  }
}
